<div class="flex justify-center pt-[130px] z-10">
  <div class="team-grid">
    <div *ngFor="let teamMember of teamMembers">
      <app-team-card [teamMember]="teamMember"></app-team-card>
    </div>
  </div>
</div>